/* global Modal */
  
if (!customElements.get('get-notified-modal')) {   
    class GetNotifiedModal extends HTMLElement {
        constructor() {
          super();
          this.documentClickHandler = this.handleDocumentClick.bind(this);
          this.close = this.querySelector('.bin-close');
          this.productTitle = this.querySelector('.js-bin-title');
          this.productSku = this.querySelector('input[name="product_sku"]');
          document.addEventListener("click", this.documentClickHandler);
          this.addEventListener('click', this.handleCloseClick); 
        }

        handleDocumentClick(evt) {
          const trigger = evt.target.closest('.js-gwt-notify-trigger');
          if (!trigger) return;

          evt.preventDefault();
          this.style.display = 'block';

          const productName = trigger.dataset.product;
          const productSku = trigger.dataset.sku;

          if (this.productTitle) {
            this.productTitle.textContent = productName ? `- ${productName}` : '';
          }
          
          if(this.productSku){
            this.productSku.value = productSku;
          }
        }

        handleCloseClick(evt){
            if(!evt.target.matches('.bin-close')) return;
            this.style.display = "none";
        }

      }
  
      customElements.define('get-notified-modal', GetNotifiedModal);
  }